// NOTE: this should probably be extracted to a separate package.

export default function replaceMinusSign(input: string): string {
    return input.replace(/^[\u002D\u2010\u2011\u2212]/, '-');
}
